module.exports = __webpack_public_path__ + "img/weMan.6386ada8.png";